import { Dimensions } from '../types'

export const checkForSquareBlock = (size: Dimensions) => size.width === size.height
